import Alert from '../../../../Modals/Alert';
import Button from '../../../../Button';
import Check from '../../../../../assets/svg/Feather/Check';
import { MAP_LAYER_IDS } from '../../../../../lib/constants';


export default (dispatch) => {
  const savingStyleChanges = () => {
    dispatch({ type: 'features/toggleEditingFeature' });
    dispatch({ type: 'map/resetWidgetState' });
    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Features Saved',
        icon: Check,
        iconColor: '#f37735',
      },
    });
    dispatch({
      type: 'features/setIsSaving',
      payload: true
    });
    dispatch({
      type: 'features/resetSelectedFeatures',
      callback: () => {
        setTimeout(() => {
          dispatch({
            type: 'features/setIsSaving',
            payload: false
          });
        }, 100)
      }
    });
    setTimeout(() => {
      dispatch({
        type: 'toast/dismiss'
      });
    }, 3500);
  }
  const showSaveFeatureError = () => {
    dispatch({
      type: 'modals/add',
      payload: {
        props: {
          title: 'There was an error saving.',
          subtitle: '',
          actionItems: [
            {
              title: 'OK',
              theme: Button.THEME.orange,
              onClick: () => {
                dispatch({
                  type: 'modals/close',
                });
              },
            },
          ],
        },
        component: Alert,
      },
    });
  }
  return {
    cancelStyleChanges: () => {
      dispatch({
        type: 'features/revertMultipleFeaturesToPreviousState',
        callback: () => {
          dispatch({ type: 'map/resetWidgetState' });
          dispatch({ type: 'features/toggleEditingFeature' });
        }
      });
    },
    updateBulkFeatures: (properties) => {
      dispatch({
        type: 'features/updateBulkFeatureStyles',
        payload: properties,
        callback: (result) => {
          if (!result) {
            showSaveFeatureError();
          } else {
            savingStyleChanges();
          }

        },
      });
    },
    updateMapFeatures: (features) => {
      dispatch({
        type: 'features/updateMultipleFeatures',
        payload: features,
      });

      dispatch({
        type: 'map/updateMultipleFeatureGraphics',
        payload: {
          features: features,
          layerId: MAP_LAYER_IDS.content,
        },
      });
    }
  }
}
